import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Extract a human-readable error message from an API error response
 * Handles both string errors and Pydantic validation errors (array of objects)
 */
export function getErrorMessage(error, fallback = "An error occurred") {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || fallback;
  }
  
  // Pydantic validation errors come as an array of objects
  if (Array.isArray(detail)) {
    const messages = detail.map(e => {
      if (typeof e === 'string') return e;
      return e.msg || e.message || JSON.stringify(e);
    });
    return messages.join(", ") || fallback;
  }
  
  // String error message
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Object error - try to extract message
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  
  return fallback;
}
